import { useSearchParams } from "react-router-dom";
import { useProjectMethods, useProjectVariables } from "../context/ProjectContext";
import "../asset/style/Tab.css";

function Tab() {
  const setPageQuery = useSearchParams()[1];
  const { setType } = useProjectMethods();
  const {type}= useProjectVariables();

  const handleClick = (e, type) => {
    setPageQuery({ page: 1 });
    setType(type);
  }

  return (
    <div>
      <ul id="panel">
        <li className={type === "all" ? "selected": ''} onClick={(e) => handleClick(e, "all")}>
          All
        </li>
        <li className={type === "public" ? "selected": ''} onClick={(e) => handleClick(e, "public")}>Public</li>
        <li className={type === "private" ? "selected": ''} onClick={(e) => handleClick(e, "private")}>Private</li>
      </ul>
    </div>
  );
}

export default Tab;
